<template>
    <div>
        <div v-if="this.loading && this.mission_detail == null">
            <LoadingSpinner></LoadingSpinner>
        </div>
        <div v-else>
            <MissionItemSummary :selected="true"
                                :mission="mission_detail"
                                :is-top="false"
                                @apply="onApply">
            </MissionItemSummary>

            <div @click="onHideFamily" class="cursor-pointer mt-2 ml-2 text-sm">
                <StopSVG class="inline"></StopSVG>
                {{ $t('component.missionDetail.hideFamiliy') }}
            </div>

            <MissionProfilePatients
                    :mission-detail="mission_detail">
            </MissionProfilePatients>

            <MissionProfileDetails
                    v-if="mission_detail.survey_version===2"
                    :mission-detail="mission_detail">
            </MissionProfileDetails>

            <MissionProfileScope
                    :mission-detail="mission_detail">
            </MissionProfileScope>

            <MissionProfileHelp
                    :mission-detail="mission_detail"
            ></MissionProfileHelp>

            <MissionProfileLivingSituation
                    :mission-detail="mission_detail">
            </MissionProfileLivingSituation>

            <div class="mx-2 mt-3">
                <MissionProfileInformationRequestButton
                        @submit="onInformationRequest">
                </MissionProfileInformationRequestButton>

                <MissionProfileApplyButton
                        @submit="onApply">
                </MissionProfileApplyButton>
            </div>

            <MissionProfileFooter
                    :mission-detail="mission_detail">
            </MissionProfileFooter>

            <portal to="modals">
                <ApplyDialog v-if="showApplyDialog"
                             :mission="mission_detail"
                             :location="mission_detail.location"
                             :date="mission_detail.arrival_date">
                </ApplyDialog>
                <InformationRequestDialog
                        v-if="showInfoRequestDialog"
                        :mission="mission_detail.mission_id">

                </InformationRequestDialog>

                <HideFamilyDialog v-if="showHideFamilyDialog"
                                  @close="$store.commit('app/hideHideFamilyDialog')"
                                  :mission="mission_detail">
                </HideFamilyDialog>

                <InformationModal v-if="showInformationApplicationLimitExceeded"
                                  @close="showInformationApplicationLimitExceeded=false" modal-type="info">
                    <template v-slot:header>{{$t('text.attention')}}:</template>
                    <template v-slot:body>{{$t('text.application_limit_exceeded')}}</template>
                </InformationModal>
            </portal>
        </div>
    </div>
</template>

<script>
    import {Portal} from 'portal-vue';
    import {mapState} from 'vuex';
    import {EventBus} from "../event-bus";
    import MissionProfileDetails from "@/components/missions/MissionProfileDetails";
    import MissionProfilePatients from "@/components/missions/MissionProfilePatients";
    import MissionProfileScope from "@/components/missions/MissionProfileScope";
    import MissionProfileHelp from "@/components/missions/MissionProfileHelp";
    import MissionProfileLivingSituation from "@/components/missions/MissionProfileLivingSituation";
    import MissionProfileApplyButton from "@/components/missions/MissionProfileApplyButton";
    import MissionProfileInformationRequestButton from "../components/missions/MissionProfileInformationRequestButton";
    import MissionProfileFooter from "@/components/missions/MissionProfileFooter";
    import MissionItemSummary from "@/components/missions/MissionItemSummary";
    import ApplyDialog from "@/components/modals/ApplyDialog";
    import StopSVG from "../components/shared/svgs/StopSVG";
    import HideFamilyDialog from "../components/modals/HideFamilyDialog";
    import InformationRequestDialog from "../components/modals/InformationRequestDialog";
    import InformationModal from "../components/modals/InformationModal";
    import LoadingSpinner from "../components/LoadingSpinner";

    export default {
        name: "MissionDetail",
        components: {
            LoadingSpinner,
            InformationModal,
            InformationRequestDialog,
            HideFamilyDialog,
            StopSVG,
            ApplyDialog,
            Portal,
            MissionItemSummary,
            MissionProfileFooter,
            MissionProfileApplyButton,
            MissionProfileInformationRequestButton,
            MissionProfileLivingSituation,
            MissionProfileHelp,
            MissionProfileScope,
            MissionProfilePatients,
            MissionProfileDetails
        },
        data() {
            return {
                mission_id: this.$route.params.mission_id,
                mission_detail: null,
                loading: false,
                showInformationApplicationLimitExceeded: false
            }
        },
        computed: {
            ...mapState('app', {
                'showApplyDialog': 'showApplyDialog',
                'showHideFamilyDialog': 'showHideFamilyDialog',
                'showInfoRequestDialog': 'showInfoRequestDialog'
            }),
        },
        async created() {
            await this.load(this.mission_id);
            EventBus.$on('onChangeLocale', this.onChangeLocaleListener);
        },
        beforeDestroy() {
            EventBus.$off('onChangeLocale', this.onChangeLocaleListener)
        },
        methods: {
            async onChangeLocaleListener() {
                await this.load(this.mission_id);
            },

            async load(mission_id) {
                this.loading = true;
                await this.$store.dispatch('mission/details', mission_id)
                    .then((mission_detail) => {
                        this.mission_detail = mission_detail;
                        this.loading = false;
                    }).catch((error) => {
                        console.log(error);
                    });
            },

            onApply() {
                if (!this.mission_detail.application_limit_exceeded) {
                    this.$store.commit('app/showApplyDialog');
                } else {
                    this.showInformationApplicationLimitExceeded = true;
                }
            },
            onInformationRequest() {
                this.$store.commit('app/showInfoRequestDialog');
            },
            onHideFamily() {
                this.$store.commit('app/showHideFamilyDialog');
            }
        }
    }
</script>

<style scoped>

</style>